import { Col, ListGroup, Row } from "react-bootstrap";
import { default as React, useMemo } from "react";
import { GenericTable } from "components/GenericTable";
import { Link } from "react-router-dom";
import { PAGE_SIZES } from "utils/pageSizeConfig";
import { createElementIdFactory, createReusableTableElementIds } from "utils/elementIds";
import "containers/common/List.css";
import "containers/common/Table.css";

import {
    createColumnHelper,
} from "@tanstack/react-table";

function OwnerPageOccupantsList({
    data = [],
    controlType,
    saveRecord,
    deleteRecord,
    updateTableState,
}) {

    const dataSet = 'occupants';

    // --- TanStack Table Setup ---
    const tableData = data || [];
    const columnHelper = createColumnHelper();
    const createId = useMemo(() => createElementIdFactory("owner-page-occupants-list"), []);
    const tableElementIds = useMemo(() => createReusableTableElementIds(createId), [createId]);

    const columns = [
        columnHelper.accessor("lease_id", {
            id: "lease_id",
            header: "ID",
            cell: ({ cell, row }) =>
                <Link to={{
                    pathname: `/properties/${row.original.property_key}/leases/${cell.getValue()}`,
                }}
                >
                    {cell.getValue()}
                </Link>,
            size: 60,
            enableSorting: true,
        }),
        columnHelper.accessor("property_key", {
            id: "property_key",
            header: "Cityscope reference",
            cell: ({ cell, row }) =>
                <Link to={{
                    pathname: `/properties/${row.original.property_key}`,
                }}
                >
                    {cell.getValue()}
                </Link>,
            size: 150,
            enableSorting: true,
        }),
        columnHelper.accessor("tenant", {
            id: "tenant",
            header: "Tenant",
            size: 300,
            enableSorting: true,
        }),
    ];

    // --- Render Functions ---
    function renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.owner_name}>
                            {d.owner_name
                            }
                        </ListGroup.Item>
                        : ""
            );
        }
    }

    function renderComponent() {
        return (
            <div className="componentRendering">
                <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>
                        {controlType === "table"
                            ? <GenericTable
                                columns={columns}
                                data={tableData}
                                section="owner-occupants-list"
                                elementIds={tableElementIds}
                                pageSize={PAGE_SIZES.ownerDetailOccupantsTab}
                                hasHeaderSorting={true}
                                meta={{
                                    updateData: (rowIndex, columnId, value) => {
                                        updateTableState(rowIndex, columnId, value, dataSet);
                                    },
                                    handleSave: async ({ row }) => {
                                        const record = row.original;

                                        if (typeof saveRecord !== "function") {
                                            return;
                                        }

                                        try {
                                            await saveRecord(dataSet, record);
                                        } catch (err) {
                                            console.error("Save failed:", err);
                                        }
                                    },
                                    handleDelete: ({ row }) => {
                                        if (typeof deleteRecord === "function") {
                                            deleteRecord(dataSet, row.original);
                                        }
                                    }
                                }}
                                enableSorting={true}
                              />
                            : <ListGroup>{renderList(tableData)}</ListGroup>
                        }
                    </Col>
                </Row>
            </div>
        );
    }
    return (
        // <div className="OwnerPageIndexList">
        <div className="OwnerPageOccupantsList">
            {renderComponent()}
        </div>
    );
}

export default OwnerPageOccupantsList;